<div
   [ngClass]="(email$ | async) !== null ? 'container sam-form-flex-row ' : 'container sam-form-flex-row k-bg-warning'"
   (click)="onClick(messageId)"
>
   <button kendoButton look="flat" class="sam-full-width primary">
      <div class="sam-full-width sam-form-flex-row">
         <ng-container *ngIf="(messageInfo$ | async) !== null; else waitlistMessageNotFound">
            <ng-container *ngIf="(email$ | async) !== null; else noSearchResultFound">
               <ng-container *ngTemplateOutlet="content"></ng-container>
            </ng-container>
         </ng-container>
      </div>
   </button>
</div>

<ng-template #icon>
   <div class="sam-center sam-margin-right">
      <fa-icon [icon]="skillTreeIcon" [fixedWidth]="true" class="email-list-icon"></fa-icon>
   </div>
</ng-template>

<ng-template #content>
   <div class="sam-form-row" style="margin-bottom: 0; width: 100%">
      <div class="sam-form-flex-row sam-margin-top">
         <ng-container *ngTemplateOutlet="icon"></ng-container>
         <div class="sam-form-row sam-ellipsis-on-overflow" style="margin-bottom: 0">
            <samweb-skill-short-info
               *ngIf="(messageInfo$ | async)?.skill !== null"
               class="skill sam-ellipsis-on-overflow"
               [skills]="(messageInfo$ | async)?.skill?.skills"
               [skillConfiguration]="(messageInfo$ | async)?.skill?.skillConfiguration"
            ></samweb-skill-short-info>
            <div class="subject sam-ellipsis-on-overflow">
               {{ (email$ | async)?.subject }}
            </div>
            <div class="from sam-ellipsis-on-overflow">
               {{ (email$ | async)?.from }}
            </div>
         </div>
      </div>
      <div class="body sam-ellipsis-on-overflow sam-margin-top">
         {{ (email$ | async)?.body | stripHtml }}
      </div>
   </div>
</ng-template>

<ng-template #waitlistMessageNotFound>
   <div class="sam-form-row" style="margin-bottom: 0">
      <div class="subject">
         {{ 'samwin.email_dialog.error_handling.message_not_found' | translate }}
      </div>
      <div class="from sam-form-flex-row">
         <div style="font-weight: bold">{{ 'samwin.email_dialog.message_id' | translate }}</div>
         <div class="sam-margin-left">{{ messageId }}</div>
      </div>
   </div>
</ng-template>

<ng-template #noSearchResultFound>
   <ng-container *ngTemplateOutlet="icon"></ng-container>
   <div class="sam-form-row" style="margin-bottom: 0">
      <div class="subject">
         {{ (messageInfo$ | async)?.subject }}
      </div>
      <div class="from">
         {{ (messageInfo$ | async)?.address }}
      </div>
      <div class="body" style="font-weight: bold">
         {{ 'samwin.email_dialog.error_handling.loading_content_failed' | translate }}
      </div>
   </div>
</ng-template>
